import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCart } from '@/context/CartContext';
import SafeIcon from '@/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { cart, setIsDrawerOpen } = useCart();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const itemCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <>
      <motion.nav 
        className={`fixed top-0 w-full z-[60] transition-all duration-500 ${
          scrolled || mobileMenuOpen ? 'bg-white border-b-2 border-black py-4' : 'bg-transparent py-6'
        }`}
      >
        <div className="max-w-[1600px] mx-auto px-6 flex items-center justify-between">
          <a href="#" className="font-black text-2xl md:text-3xl tracking-tighter uppercase group relative">
            PrismPeak
            <span className="absolute -bottom-1 left-0 w-0 h-1 prism-gradient transition-all duration-300 group-hover:w-full"></span>
          </a>
          
          <div className="hidden lg:flex gap-10">
            {['DROPS', 'FIT GUIDE', 'LENS LAB'].map((name) => (
              <a key={name} href={`#${name.toLowerCase().replace(' ', '')}`} className="text-[10px] font-black tracking-[0.3em] hover:prism-text transition-all">
                {name}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-4">
            <button 
              onClick={() => setIsDrawerOpen(true)}
              className="flex items-center gap-3 bg-black text-white px-6 py-3 rounded-none text-[10px] font-black tracking-[0.2em] hover:prism-gradient transition-all group relative focus:ring-2 focus:ring-offset-2 focus:ring-black"
              aria-label={`View Bag with ${itemCount} items`}
            >
              <SafeIcon icon={FiIcons.FiShoppingBag} className="text-lg" />
              <span className="hidden sm:inline">BAG ({itemCount})</span>
              {itemCount > 0 && (
                <motion.span 
                  initial={{ scale: 0 }} animate={{ scale: 1 }}
                  className="absolute -top-2 -right-2 w-5 h-5 bg-white text-black border border-black flex items-center justify-center text-[8px]"
                >
                  {itemCount}
                </motion.span>
              )}
            </button>

            <button 
              className="lg:hidden p-2 border-2 border-black"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle Menu"
            >
              <SafeIcon icon={mobileMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} />
            </button>
          </div>
        </div>
      </motion.nav>

      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, x: '100%' }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: '100%' }}
            className="fixed inset-0 z-[55] bg-white pt-32 px-10 lg:hidden flex flex-col"
          >
            {['DROPS', 'FIT GUIDE', 'LENS LAB', 'ACCOUNT'].map((item) => (
              <a 
                key={item} 
                href={`#${item.toLowerCase().replace(' ', '')}`}
                onClick={() => setMobileMenuOpen(false)}
                className="text-6xl font-black tracking-tighter uppercase border-b-2 border-black py-6 hover:prism-text transition-all"
              >
                {item}
              </a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;